import ImageText from "../common/ImageText";
import Counter_holly from "../common/Counter_holly";
import ProductDescription from "../common/ProductDescription";
import Collapsible from "../common/Collapsible";
import TechSpecs from "../common/TechSpecs";
import ProductSlider from "../common/ProductSlider";
import EmailPopup from '../common/EmailPopup';
import "../global.css";
import { Link } from "react-router-dom";
import React, {useEffect, useState} from "react";
import OverlayForm from "../components/OverlayForm";
import SliderHolly from "../common/SliderHolly";
import { Helmet } from "react-helmet-async";
import Counter from "../common/Counter";
import SliderMara from "../common/SliderMara";
export default function Mara() {

  useEffect(() => {
    if (window.location.hash) {
      let newPath = window.location.pathname + window.location.search;
      if (newPath.endsWith('/')) {
        console.log("termina con /", newPath)
        newPath = newPath.slice(0, -1);
        console.log("newPath", newPath)
      }
      window.history.pushState("", document.title, newPath);
    }
  }, []);

  
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [fileType, setFileType] = useState<string | null>(null);

  const handleRequestClick = () => {
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  return (
      <div>
          <Helmet>
              <title>{"Mara | Revolv Space"}</title>
              <meta name="description" content={"RADIATION-TOLERANT SOLAR ARRAY DRIVE ASSEMBLY DEVELOPED FOR FOR 300-1000KG SATELLITES AND TALORED TO LEO CONSTELLATIONS"} />
          </Helmet>

          {/* IMMAGINE PRODOTTO — solo DESKTOP (absolute, com'era) */}
          <div className="hidden md:block">
              <img
                  src="/products/Mara/MARA.png"
                  alt="mara"
                  className="absolute mt-2 px-[15rem] lg:px-[20rem] xl:px-[30rem] 2xl:px-[40rem] w-full h-auto object-cover opacity-75 bg-transparent"
                  data-aos="fade-zoom-in"
                  data-aos-offset="200"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="600"
                  data-aos-once="true"
              />
          </div>

          <div className="relative flex flex-col h-full mt-8 md:mt-20">
              {/* TITLE Section — 1 colonna su mobile, 2 su desktop */}
              <div className="grid grid-cols-1 md:grid-cols-2 z-40 mb-4">
                  <div>
                      <div className="flex flex-row">
                          <h1 className="opacity-0 animate-fadeIn delay-0 md:w-4/6 mx-12 mt-24 md:mt-24 2xl:text-7xl xl:text-7xl lg:text-7xl text-4xl leading-120 tracking-tighter text-left uppercase font-bold text-white dark:text-white">
                              MARA
                          </h1>
                      </div>

                      {/* IMMAGINE PRODOTTO — solo MOBILE (in-flow, impilata) */}
                      <img
                          src="/products/Mara/MARA.png"
                          alt="mara"
                          className="block md:hidden w-full h-auto px-16  opacity-90"
                          data-aos="fade-zoom-in"
                          data-aos-offset="200"
                          data-aos-easing="ease-in-sine"
                          data-aos-duration="600"
                          data-aos-once="true"
                      />

                      <div className="opacity-0 animate-fadeIn delay-1 mx-12 uppercase 2xl:text-2xl xl:text-2xl lg:text-2xl  md:pt-20 text-1xl text-white leading-34 tracking-tight text-left max-w-full md:max-w-1/2">
                          A radiation-tolerant <br/> Solar Array Drive Assembly <br/> developed for 300-1000 kg <br/>satellites and tailored to <br/>LEO constellations <br/> <br/> <strong>TRL 7</strong>
                      </div>
                  </div>

            <div className="h-screen">          <div className=" col-span-2 md:col-span-1 flex justify-center md:justify-end z-40 my-16 mb-12 hidden">
                <div className=" grid grid-cols-1 flex gap-8 sm:mt-0 text-white md:mr-20 opacity-0 animate-fadeIn delay-1 "
                >


                    {/*<Counter
                    type="custom"
                    start={0}
                    end={3}
                    unit=""
                    customLabel="MONTHS"
                    upperText="LEAD TIME"
                />*/}
                    <Counter
                        type="custom"
                        start={"PCBTLBYLR"}
                        end={"COMING SOON"}
                        unit=""
                        customLabel="STAY TUNED"
                        upperText="LEAD TIME"
                    />
                    {/*<Counter
                    type="custom"
                    start={0}
                    end={3}
                    unit=".5 K€"
                    customLabel="PER UNIT"
                    upperText="PRICE"
                />*/}
                    <Counter
                        type="custom"
                        start={"PCBTLBYLR"}
                        end={"COMING SOON"}
                        unit=""
                        customLabel="STAY TUNED"
                        upperText="PRICE PER UNIT"
                    />
                    <h1 className="text-md uppercase pt-4 text-center mx-auto w-64">Price and lead times are coming soon. Get in Touch for further informations.</h1>

                </div>
            </div>
            </div>


        </div>
          <div
              className="flex flex-col  sm:flex-row justify-center items-center gap-2 md:gap-24 py-12 font-bold"
              data-aos="fade-zoom-in"
              data-aos-offset="200"
              data-aos-easing="ease-in-sine"
              data-aos-duration="600"
            >
              {/*<Link to="">*/}
              {/* <Link to="https://holly.revolvspace.com" target="_blank" rel="noopener noreferrer">
              <button
                className="rounded-full w-auto h-10 text-center text-white  px-4 transform transition-transform duration-200 hover:scale-110"
                style={{
                  background:
                    "linear-gradient(90deg, #00858F 0%, #E6007E 100%)",
                }}
                onClick={() => {/* handleRequestClick() */}{/*}}*/}
              {/* >
              ACCESS PRODUCT GUIDE
          </button>
      </Link>*/}
              
              {/* </Link>*/}
              <a href="/pdf/MARA.00.001.rev7_Technical_datasheet.pdf" download="MARA-datasheet.pdf">
                <button
                    className="rounded-full w-auto h-12 font-bold text-center text-white px-8 transform transition-transform duration-200 hover:scale-110"
                  style={{
                    background:
                      "linear-gradient(90deg, #00858F 0%, #E6007E 100%)",
                  }}
                  
                >
                  DOWNLOAD DATASHEET
                </button>
              </a>
              <button
                  className="rounded-full w-auto h-12 font-bold text-center text-white px-8 transform transition-transform duration-200 hover:scale-110"
                style={{
                  background:
                    "linear-gradient(90deg, #00858F 0%, #E6007E 100%)",
                }}
                onClick={() => handleRequestClick()}
              >
                REQUEST QUOTATION
              </button>
              
            </div>
        {/*ANIMATED BLOCKS*/}
        <div className="  h-full flex flex-col  z-0 my-20">

          <div className=" grid grid-cols-1 md:grid-cols-3 gap-4 px-2 sm:mt-0 text-white">

              {/*
              <Counter_holly type="letter" start="" end="DEPLOYMENT" />
            <Counter_holly type="power" start={0.1} end={10} unit="X" />
            <Counter_holly type="watt" start="" end="LATCHING"   />
              */}

              <Counter
                  type="custom"
                  start={0}
                  end={14}
                  unit="KG m²"
                  customLabel="solar wing moment of inertia"
                  upperText="UP TO"
              />
              <Counter
                  type="custom"
                  start={0}
                  end={7280}
                  unit="W"
                  customLabel="power transfer per unit @100V"
                  upperText="UP TO"
              /><Counter
              type="custom"
              start={"PCBTLBYLR"}
              end={"REDUNDANT"}
              unit="W"
              customLabel="in power transfer and drive electronics"
              upperText="FULLY"
          />

          </div>
        </div>
        <div id='main-features' className="h-20"></div>

        




        























        {/* COLLAPSIBLE Section */}
       
        {/*AVAILABLE VERSIONS Section*/}
          {/*Se serve inserire da HOLLY */}


          <div id="tech-specs" className="h-10"></div>
          {/* TECHNICAL SPECIFICATIONS Section */}
          <div  className="h-full flex flex-col bg-black bg-opacity-50 z-40 mb-40">
              {/* Your content here */}
              <h1
                  data-aos="fade-zoom-in"
                  data-aos-offset="300px"
                  data-aos-delay="0"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="600"
                  className=" my-12 text-4xl md:text-5xl leading-120 tracking-tighter text-center uppercase font-bold text-white ">
                  TECHNICAL SPECIFICATIONS{" "}
              </h1>

              <div>
                  <div className="grid  md:grid-cols-4  gap-4 px-4 sm:grid-cols-1 " >

                      <div
                          data-aos="fade-zoom-in"
                          data-aos-offset="300px"
                          data-aos-delay="400"
                          data-aos-easing="ease-in-sine"
                          data-aos-duration="600">
                          <TechSpecs
                              title="MECHANICAL SPECIFICATIONS"
                              description={[
                                  { title: "Size: ", description: "230x163x100mm" },
                                  { title: "Mass: ", description: "5kg" },
                                  { title: "Rotation range: ", description: "355 deg" },
                                  { title: "Rotation speed: ", description: "0-2 deg/s" },

                                  {
                                      title: "Maximum output torque (ECSS-compliant): ",
                                      description: "10 Nm",
                                  },
                                  { title: "Pointing accuracy: ", description: "1 deg" },
                                  { title: "Stiffness – axial: ", description: " 2.5E7 N/m" },
                                  { title: "Stiffness – radial: ", description: "1.5E7 N/m" },
                                  { title: "Stiffness – bending: ", description: "15E3 Nm/rad" },
                                  { title: "Stiffness – torsional: ", description: "1.0E3 Nm/rad" },
                                  { title: "Maximum loads – axial: ", description: "2000 N" },
                                  { title: "Maximum loads – radial: ", description: "3000 N" },
                                  { title: "Maximum loads – bending: ", description: "200 Nm"},
                              ]}

                          />
                          <p className="text-xs text-white/50 mt-3 text-center uppercase">
                              *Maximum loads are applied independently. Specific load combinations require ad-hoc verification.
                          </p>
                      </div>
                      <div
                          data-aos="fade-zoom-in"
                          data-aos-offset="300px"
                          data-aos-delay="700"
                          data-aos-easing="ease-in-sine"
                          data-aos-duration="600"
                      >
                          <TechSpecs
                              title="POWER TRANSFER SPECIFICATIONS"
                              description={[
                                  { title: "Power/signal transfer method:  ", description: "Twist capsule (flexible printed circuits)" },
                                  { title: "Maximum power transferred:  ", description: "7280 W @100 V" },
                                  { title: "Power / signal interface:  ", description: "Micro-D Sub (can be customized)" },
                                  { title: "Maximum number of signal tracks: ", description: "32" },
                                  { title: "Maximum open circuit voltage:  ", description: "200 V" },
                              ]}

                          />
                      </div>
                      <div
                          data-aos="fade-zoom-in"
                          data-aos-offset="300px"
                          data-aos-delay="1000"
                          data-aos-easing="ease-in-sine"
                          data-aos-duration="600"
                      >
                          <TechSpecs
                              title="DRIVE ELECTRONICS SPECIFICATIONS"
                              description={[
                                  { title: "Power consumption (@28 V): ", description: "Idle: <4 W\nActuation: <9 W\nAverage: <5 W" },
                                  { title: "Power supply: ", description: "28 V (15-50 V unregulated)" },
                                  { title: "Communication interface: ", description: "RS-485" },
                                  { title: "TID (component level): ", description: "30 krad" },
                                  { title: "SEE tolerance: ", description: "SEL-free below LET 38.8 MeV cm2 / mg" },

                              ]}

                          />
                      </div>
                      <div
                          data-aos="fade-zoom-in"
                          data-aos-offset="300px"
                          data-aos-delay="1300"
                          data-aos-easing="ease-in-sine"
                          data-aos-duration="600"
                      >
                          <TechSpecs
                              title="ENVIRONMENTAL SPECIFICATIONS"
                              description={[
                                  { title: "Operating temperature range: ", description: " -40 / +70 °C" },
                                  { title: "Survival temperature range: ", description: "-50 / +80 °C" },
                                  { title: "Target environment and lifetime:  ", description: " LEO (7 years)\nGEO (restricted by radiation dose)" },
                                  {
                                      title: "Vibration environment: ",
                                      description: "NASA GEVS and ECSS-E-HB-32-26A",
                                  },
                              ]}

                          />
                      </div>
                  </div>
              </div>
          </div>

          <div className="relative  text-white grid grid-cols-3 h-full sm:px-10  pt-20 mb-64  ">
              {/* USE CASES SECTION */}
              <h1 data-aos="fade-zoom-in"
                  data-aos-offset="100px"
                  data-aos-delay="0"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="600"
                  className=" my-12 col-span-3 text-5xl leading-120 tracking-tighter text-center uppercase font-bold text-white ">
                  USE CASES{" "}
              </h1>



              <div className="mt-[4rem] flex flex-col items-center col-span-3  md:col-span-1 ">

                  <img className="my-2 w-[10rem]" style={{ filter: "brightness(0) invert(1)" }} src={"/IMAGES/MARA use cases/satcom.png"} alt="1" />

                  <div className=" uppercase    text-center   ">
                      {/* <div className="font-bold">SmallSat EU</div>*/}
                      <div className="text-xl ">SATELLITE<br/>COMMUNICATIONS</div>

                  </div>
              </div>



              <div className="mt-[4rem] flex flex-col items-center col-span-3  md:col-span-1">
                  <img className="my-2 w-[10rem]" style={{ filter: "brightness(0) invert(1)" }} src={"/IMAGES/MARA use cases/AI on board and edge computing.png"} alt="1" />

                  <div className=" uppercase  text-center  ">
                      {/* <div className="font-bold">SmallSat EU</div>*/}
                      <div className="text-xl">AI ON-BOARD AND<br/>EDGE COMPUTING</div>

                  </div>
              </div>

              <div className="mt-[4rem] flex flex-col items-center col-span-3  md:col-span-1">
                  <img className="my-2 w-[10rem] " style={{ filter: "brightness(0) invert(1)" }} src={"/IMAGES/MARA use cases/SAR.png"} alt="1" />

                  <div className=" uppercase text-center  ">
                      {/* <div className="font-bold">SmallSat EU</div>*/}
                      <div className="text-xl">SEARCH AND<br/>RESCUE</div>

                  </div>
              </div>

              <div className="mt-[4rem] flex flex-col items-center col-span-3  md:col-span-1">
                  <img className="my-2 w-[10rem]" style={{ filter: "brightness(0) invert(1)" }} src={"/IMAGES/MARA use cases/responsive space.png"} alt="1" />

                  <div className=" uppercase  text-center  ">
                      {/* <div className="font-bold">SmallSat EU</div>*/}
                      <div className="text-xl">RESPONSIVE<br/>SPACE</div>

                  </div>
              </div>


              {/*row 2*/}
              <div className="mt-[4rem] flex flex-col items-center col-span-3  md:col-span-1">
                  <img className="my-2 w-[10rem]" style={{ filter: "brightness(0) invert(1)" }} src={"/IMAGES/MARA use cases/mid-latitude flights.png"} alt="1" />

                  <div className=" uppercase  text-center  ">
                      {/* <div className="font-bold">SmallSat EU</div>*/}
                      <div className="text-xl">MID-LATITUDE<br/>FLIGHTS</div>

                  </div>
              </div>
              <div className="mt-[4rem] flex flex-col items-center col-span-3  md:col-span-1">
                  <img className="my-2 w-[10rem]" style={{ filter: "brightness(0) invert(1)" }} src={"/IMAGES/MARA use cases/OTV and space tugs.png"} alt="1" />

                  <div className=" uppercase  text-center  ">
                      {/* <div className="font-bold">SmallSat EU</div>*/}
                      <div className="text-xl">OTV AND<br/>SPACE TUGS</div>

                  </div>
              </div>
              <div className="mt-[4rem] flex flex-col items-center col-span-3  md:col-span-1">
                  <img className="my-2 w-[10rem]" style={{ filter: "brightness(0) invert(1)" }} src={"/IMAGES/MARA use cases/multi-plane constellations.png"} alt="1" />

                  <div className=" uppercase  text-center  ">
                      {/* <div className="font-bold">SmallSat EU</div>*/}
                      <div className="text-xl">MULTI-PLANE<br/>CONSTELLATIONS</div>

                  </div>
              </div>
              <div className="mt-[4rem] flex flex-col items-center col-span-3  md:col-span-1">
                  <img className="my-2 w-[10rem]" style={{ filter: "brightness(0) invert(1)" }} src={"/IMAGES/MARA use cases/GEO.png"} alt="1" />

                  <div className=" uppercase  text-center  ">
                      {/* <div className="font-bold">SmallSat EU</div>*/}
                      <div className="text-xl">GEOSYNCHRONUS<br/>EQUATORIAL ORBIT</div>

                  </div>
              </div>
              <div className="mt-[4rem] flex flex-col items-center col-span-3  md:col-span-1">
                  <img className="my-2 w-[10rem]" style={{ filter: "brightness(0) invert(1)" }} src={"/IMAGES/MARA use cases/lunar and deep space.png"} alt="1" />

                  <div className=" uppercase  text-center  ">
                      {/* <div className="font-bold">SmallSat EU</div>*/}
                      <div className="text-xl">LUNAR AND<br/>DEEP-SPACE</div>

                  </div>
              </div>

          </div>


          {/* QUALIFICATION Section */}
          <div className="h-full flex flex-col bg-black bg-opacity-50 z-40 mt-4 mb-40" >
              {/* Your content here */}
              <h1
                  data-aos="fade-zoom-in"
                  data-aos-offset="300px"
                  data-aos-delay="0"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="600"
                  className=" my-12 text-4xl md:text-5xl leading-120 tracking-tighter text-center uppercase font-bold text-white ">
                  QUALIFICATION{" "}
              </h1>

              <div>
                  <div className="grid text-center mt-4 md:grid-cols-4 gap-4 px-4 sm:grid-cols-1 gap-y-20 align-top " data-aos="zoom-out-in"
                       data-aos-offset="200"
                       data-aos-easing="ease-in-sine"
                       data-aos-duration="600">
                      <div className="value-item "
                           data-aos="fade-zoom-in"
                           data-aos-offset="300px"
                           data-aos-delay="400"
                           data-aos-easing="ease-in-sine"
                           data-aos-duration="600">
                          <ImageText
                              text="mechanical"
                              imageSrc="/products/product_q_mechanical.svg"
                              description="STATIC LOADS, RANDOM AND SINE VIBRATIONS, AND SHOCK TESTING ACCORDING TO NASA GEVS"
                              textAlign="center"
                          />
                      </div>
                      <div className="value-item"
                           data-aos="fade-zoom-in"
                           data-aos-offset="300px"
                           data-aos-delay="800"
                           data-aos-easing="ease-in-sine"
                           data-aos-duration="600">
                          <ImageText
                              text="THERMAL VACUUM"
                              imageSrc="/products/product_q_thermal.svg"
                              description="8 CYCLES IN OPERATIONAL TEMPERATURE RANGE, WITH DEPLOYMENT AND ACTUATION"
                              textAlign="center"
                          />
                      </div>
                      <div className="value-item"
                           data-aos="fade-zoom-in"
                           data-aos-offset="300px"
                           data-aos-delay="1200"
                           data-aos-easing="ease-in-sine"
                           data-aos-duration="600">
                          <ImageText
                              text="radiation"
                              imageSrc="/products/product_q_radiation.svg"
                              description={"Proton test: 30, 50, 100 mev\n" +
                                  "Heavy ion test: let 38.8 mev cm2/mg\n" +
                                  "Tid test: 30 krad"}
                              textAlign="center"
                          />
                      </div>
                      <div className="value-item"
                           data-aos="fade-zoom-in"
                           data-aos-offset="300px"
                           data-aos-delay="1600"
                           data-aos-easing="ease-in-sine"
                           data-aos-duration="600">
                          <ImageText
                              text="lifetime"
                              imageSrc="/products/product_q_lifetime.svg"
                              description="7 years accelerated lifetime test in thermal vacuum"
                              textAlign="center"
                          />
                      </div>
                  </div>
              </div>
          </div>

          {/*PRODUCT DESCRIPTION SECTION*/}

          <div className="h-full flex flex-col bg-black bg-opacity-50 z-40 mt-4 mb-40 px-10 ">
              <div data-aos="fade-zoom-in"
                   data-aos-offset="100px"

                   data-aos-easing="ease-in-sine"
                   data-aos-duration="600"
                   data-aos-once="true">
                  <ProductDescription
                      title="NO SLIP RINGS"
                      description="MARA’s flexible printed circuit (FPC)-based power transfer technology guarantees low lead times, an affordable price, and high flexibility to adapt to several solar array designs."          />
              </div>

              <div data-aos="fade-zoom-in"
                   data-aos-offset="100px"
                   data-aos-delay="500"
                   data-aos-easing="ease-in-sine"
                   data-aos-duration="600"
                   data-aos-once="true">
                  <ProductDescription
                      title="COMPACT DESIGN IN CRITICAL DIMENSION"
                      description="MARA’s 90° shaft arrangement ensures superior compactness along the solar array rotation axis (<100 mm), occupying volume parallel to the spacecraft wall and avoiding interference with existing avionics or payloads."
                  />
              </div>
              <div
                  data-aos="fade-zoom-in"
                  data-aos-offset="100px"
                  data-aos-delay="1000"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="600"
                  data-aos-once="true">
                  <ProductDescription
                      title="COLD REDUNDANCY"
                      description="MARA features a double-winding motor, with each winding connected to a separate drive electronics unit and separate connectors to guarantee cold redundancy in all modes of operation."
                  />
              </div>
              <div
                  data-aos="fade-zoom-in"
                  data-aos-offset="100px"
                  data-aos-delay="1000"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="600"
                  data-aos-once="true">
                  <ProductDescription
                      title="FLEXIBLE MOUNTING"
                      description="MARA offers mechanical interfaces for different mounting configurations: inside or outside the main spacecraft wall, guaranteeing high flexibility and adaptability across several satellite bus designs."
                  />
              </div>

              <div
                  data-aos="fade-zoom-in"
                  data-aos-offset="100px"
                  data-aos-delay="1000"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="600"
                  data-aos-once="true">
                  <ProductDescription
                      title="ENHANCED RADIATION TOLERANCE"
                    description="The MARA drive electronics has been tested thoroughly for TID and SEE, with both proton and heavy ion tests performed on critical components, rating the system at 30 krad at board level with an LET threshold of LET 38.8 MeV*cm2/mg."
                  />
              </div>
          </div>




          <div className="px-10">
          <div
            className="flex items-center justify-center"
            data-aos="fade-zoom-in"
            data-aos-offset="200"
            data-aos-easing="ease-in-sine"
            data-aos-duration="600"
          >

          <div>
            <div>
              {/* RENDER prima della PRODUCT GALLERY */}
              <img
          src="/products/Mara/MARA.png"
          alt="MARA"
          className=" hidden relative  w-auto  md:h-[20rem] xl:h-[30rem] object-cover opacity-75 bg-transparent "
          data-aos="fade-zoom-in"
          data-aos-offset="200"
          data-aos-easing="ease-in-sine"
          data-aos-duration="600"
          data-aos-once="true"
        />
            </div>
          </div>
            
          </div>
          <div>
            {/*cta download*/}
            
          </div>

         

          
          

        </div>

              {/*VIDEO Section */}
              <div className="w-full my-40">
                  <div className="relative w-full" style={{ paddingBottom: "56.25%" }}>
                      <iframe
                          className="absolute top-0 left-0 w-full h-full"
                          src="https://player.vimeo.com/video/1202511834?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                          frameBorder="0"
                          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                          referrerPolicy="strict-origin-when-cross-origin"
                          title="Filippo Oggionni on Revolv Space: MARA"
                      />
                  </div>
              </div>

              {/*VIDEO Section */}
              <div className="w-full my-40">
                  <div className="relative w-full" style={{ paddingBottom: "56.25%" }}>
                      <iframe
                          className="absolute top-0 left-0 w-full h-full"
                          src="https://player.vimeo.com/video/1202511803?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                          frameBorder="0"
                          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                          referrerPolicy="strict-origin-when-cross-origin"
                          title="Get to know MARA - TRL 6"
                      />
                  </div>
              </div>
    
        {/* PRODUCT GALLERY Section */}
        <div className="h-full flex flex-col bg-black bg-opacity-50 z-40 mb-40 my-40">
          {/*  */}
          <h1
              data-aos="fade-zoom-in"
              data-aos-offset="300px"
              data-aos-delay="0"
              data-aos-easing="ease-in-sine"
              data-aos-duration="600"
              className="mb-4 mt-40  text-3xl md:text-5xl leading-120 tracking-tighter text-center uppercase font-bold text-white ">
            PRODUCT GALLERY{" "}
          </h1>

          <div data-aos="fade-zoom-in"
               data-aos-offset="300px"
               data-aos-delay="300"
               data-aos-easing="ease-in-sine"
               data-aos-duration="600">
            <SliderMara />
          </div>
        </div>

        <Link to="/contact">
          <div className="flex items-center justify-center pb-16">
            <button
                className="rounded-full w-auto h-12 font-bold text-center text-white px-8 transform transition-transform duration-200 hover:scale-110"
              style={{
                background: "linear-gradient(90deg, #00858F 0%, #E6007E 100%)",
              }}
            >
              CONTACT US
            </button>
          </div>
        </Link>
      </div>
      {/* {isPopupOpen && fileType && (
          <EmailPopup fileType={fileType} onClose={handleClosePopup} />
      )}*/}
      {isPopupOpen && (
          <OverlayForm
              formUrl="https://webforms.pipedrive.com/f/6UR9Re8nR5VKrsxbJHNTBDLcsXv6xjIStMZYDU4iiOvEJdEo7cZwg4M1uAm9NAG7WX"
              onClose={handleClosePopup}
          />
      )}
    </div>
  );
}
